<template> 

    <div >
 
    <div  >
      <div class="max-w-5xl mx-auto">
        <div class="flex flex-wrap items-center justify-between -mt-2 -ml-4 sm:flex-no-wrap">
          <div class="mt-2 ml-4">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Piatti
            </h3>
          </div>
          <div v-if="!showEmpty" class="flex-shrink-0 mt-2 ml-4">
            <span class="inline-flex rounded-md shadow-sm">
              <router-link :to="{ name : 'DishCreate',  params : { id: this.id }}" type="button" class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700">
                Crea nuovo
              </router-link>
            </span>
          </div>
        </div>
      </div>

      <div class="max-w-5xl mx-auto mt-5">
        <div class="flex flex-col">

          <div v-if="showEmpty">
            <div class="inline-block min-w-full p-5 mt-2 overflow-hidden text-center align-middle bg-white border-b border-gray-200 shadow sm:rounded-lg">

            <div class="mx-auto">
              <div class="flex items-center justify-center flex-shrink-0 mx-auto rounded-full">
                  <svg class="text-red-600 w-14 h-14" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                  </svg>
              </div>
            </div>

              <p class="mt-2 text-lg">Per inserire i piatti è necessario creare le categorie</p>

              <router-link :to="{ name : 'CategoryCreate',  params : { id }}" type="button" class="relative inline-flex items-center px-4 py-2 mt-4 text-sm font-medium leading-5 text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700">
                Crea nuova categoria
              </router-link>

            </div>
          </div>

          <div :id="'cat'+category.id" v-for="(category, index) in categories" :key="category.id" class="my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
            <div class="" :class="index > 0 ? 'mt-4' : ''">
              <div class="flex justify-between">
                <router-link :to="{ name : 'Category',  params : { id, idcategory: category.id }}" class="flex items-end">
                <div  v-if="category.url != null && category.url != ''">
                  <object :data="getCategoryIcon(category.url)" class="inline-block w-5 h-5" ></object>
                </div>
                <h2 class="ml-2 text-sm font-bold leading-none tracking-wide text-gray-500 uppercase lg:text-xs hover:text-indigo-600">
                  {{category.name}}
                </h2>
                <div>
                  <svg class="w-3.5 h-3.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
                    <path class="heroicon-ui" d="M9.3 8.7a1 1 0 0 1 1.4-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.4-1.4l3.29-3.3-3.3-3.3z"/>
                  </svg>
                </div>
                </router-link>
                <div>
                  <router-link :to="{ name : 'DishCreate',  params : { id, catid: category.id }}" class="flex items-center pr-1 text-sm font-semibold text-indigo-600">
                    <div class="">
                      <svg class="w-3.5 h-3.5 text-indigo-600 fill-current " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path class="heroicon-ui" d="M17 11a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4H7a1 1 0 0 1 0-2h4V7a1 1 0 0 1 2 0v4h4z"/>
                      </svg>
                    </div> 
                    <div class="ml-0.5">Aggiungi piatto</div>
                  </router-link>
                </div>
              </div>
              
            </div>
            <div class="inline-block min-w-full mt-2 overflow-hidden align-middle border-b border-gray-200 shadow sm:rounded-lg">

              
              <table class="min-w-full table-fixed">
                <thead>
                  <tr>
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 lg:w-1/3 bg-gray-50">
                      Nome
                    </th>
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 lg:w-1/12 bg-gray-50">
                      Prezzo
                    </th>
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 lg:w-1/6 bg-gray-50">
                      Allergeni
                    </th>
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 lg:w-1/6 bg-gray-50">
                      Attributi
                    </th>
                    <th class="px-6 py-3 border-b border-gray-200 lg:w-1/12 bg-gray-50">
                      
                    </th>
                  </tr>
                </thead>

                <tbody class="bg-white">
                  <router-link tag="tr" class="cursor-pointer hover:bg-gray-50" :to="{name:'Dish', params:{ id: id, iddish: dish.id}}" v-for="dish in getDishesOfCategory(category)" :key="dish.id">
                    <td class="px-6 py-4 text-sm font-medium leading-5 text-gray-900 border-b border-gray-200">
                                            <div class="flex items-center">
                        <div class="flex-shrink-0 w-10 h-10">
                          <img v-if="dish.image != null && dish.image != ''" :src="getDishImage(dish.image+'.jpg')" class="object-cover w-10 h-10" :alt="dish.name" />
                          <div v-else class="w-10 h-10 rounded-full">
                            <svg class="w-10 h-10" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" height="512" width="512">
                              <g clip-rule="evenodd" fill-rule="evenodd">
                                <path d="M256 66c104.934 0 190 85.066 190 190s-85.066 190-190 190S66 360.934 66 256 151.066 66 256 66zm246 190c0-135.862-110.138-246-246-246S10 120.138 10 256s110.138 246 246 246 246-110.138 246-246z" fill="#fff" data-original="#FFF"/>
                                <path d="M445.999 256c0-104.934-85.066-190-190-190C151.066 66 66 151.066 66 256s85.066 190 190 190c104.933 0 189.999-85.066 189.999-190zm-172.062-58.794c0-27.614 20.147-67.362 45-67.362s45 39.747 45 67.362c0 19.632-10.183 32.9-25 38.928v126.023c0 11-9 20-20 20s-20-9-20-20v-126.02c-14.817-6.031-25-19.299-25-38.931zm-61.75 47.245v117.706c0 10.999-9 20-20 20s-20-9-20-20V244.45c-11.933-6.942-20-19.877-20-34.605v-9.999h80v9.999c0 14.727-8.066 27.663-20 34.606z" fill="#fff" data-original="#FFF"/>
                                <path d="M212.187 244.45c11.934-6.942 20-19.878 20-34.605v-9.999h-80v9.999c0 14.728 8.066 27.663 20 34.605a39.662 39.662 0 0020 5.395 39.66 39.66 0 0020-5.395z" fill="#c3dafe" data-original="#C3DAFE" data-old_color="#b6bccf"/>
                                <path d="M212.187 362.157V244.451c-5.892 3.428-12.728 5.395-20 5.395s-14.108-1.967-20-5.395v117.706c0 11 9 20 20 20 11-.001 20-9.001 20-20z" fill="#5850ec" data-original="#5850EC" data-old_color="#ff764e"/>
                                <path d="M273.937 197.206c0 19.632 10.183 32.9 25 38.931 6.025 2.452 12.816 3.708 20 3.708s13.975-1.255 20-3.708c14.817-6.031 25-19.299 25-38.931 0-27.614-20.147-67.362-45-67.362s-45 39.748-45 67.362z" fill="#c3dafe" data-original="#C3DAFE" data-old_color="#b6bccf"/>
                                <path d="M298.937 236.134v126.023c0 11 9 20 20 20s20-9 20-20v-126.02c-6.025 2.452-12.816 3.708-20 3.708-7.184-.001-13.975-1.256-20-3.711z" fill="#5850ec" data-original="#5850EC" data-old_color="#ff764e"/>
                              </g>
                              <path d="M256 0C114.841 0 0 114.841 0 256s114.841 256 256 256 256-114.841 256-256S397.159 0 256 0zm0 492C125.869 492 20 386.131 20 256S125.869 20 256 20s236 105.869 236 236-105.869 236-236 236z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#414141"/>
                              <path d="M256 56c-61.174 0-118.174 27.455-156.385 75.324-3.445 4.317-2.739 10.609 1.577 14.054s10.608 2.739 14.054-1.577C149.64 100.713 200.943 76 256 76c99.252 0 180 80.748 180 180s-80.748 180-180 180S76 355.252 76 256c0-11.934 1.175-23.867 3.493-35.468 1.082-5.416-2.431-10.683-7.847-11.765-5.41-1.083-10.683 2.431-11.765 7.847A201.39 201.39 0 0056 256c0 110.28 89.72 200 200 200s200-89.72 200-200S366.28 56 256 56z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#414141"/>
                              <path d="M152.187 129.844c-5.523 0-10 4.477-10 10v70.001c0 16.323 7.864 30.841 20 39.972v112.339c0 16.542 13.458 30 30 30s30-13.458 30-30V249.818c12.136-9.131 20-23.65 20-39.973v-70.001c0-5.523-4.477-10-10-10s-10 4.477-10 10v50.002h-20v-50.002c0-5.523-4.477-10-10-10s-10 4.477-10 10v50.002h-20v-50.002c0-5.523-4.477-10-10-10zm50 232.313c0 5.514-4.486 10-10 10s-10-4.486-10-10V258.839c3.232.659 6.576 1.006 10 1.006s6.768-.347 10-1.006zm-10-122.312c-16.542 0-29.999-13.458-30-29.999l60-.001c0 16.542-13.458 30-30 30zM318.937 392.156c16.542 0 30-13.458 30-30V242.324c15.496-8.888 25-25.036 25-45.118 0-15.76-5.472-34.165-14.636-49.232-11.033-18.139-25.368-28.129-40.364-28.129s-29.331 9.99-40.364 28.129c-9.165 15.068-14.636 33.473-14.636 49.232 0 20.083 9.504 36.231 25 45.118v119.833c0 16.542 13.458 29.999 30 29.999zm10-29.999c0 5.514-4.486 10-10 10s-10-4.486-10-10v-113.05a68.038 68.038 0 0020 0zm-10-222.313c7.633 0 16.117 6.751 23.276 18.522 7.232 11.889 11.724 26.772 11.724 38.839 0 24.065-18.08 32.639-35 32.639s-35-8.574-35-32.639c0-23.988 17.637-57.361 35-57.361zM83.698 185.802h.007c5.523 0 9.997-4.477 9.997-10s-4.481-10-10.004-10-10 4.477-10 10 4.477 10 10 10z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#414141"/>
                            </svg>
                          </div>

                        </div>
                        <div class="ml-4">
                          <div class="text-sm font-medium leading-5 text-gray-900">{{dish.name}}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-no-wrap border-b border-gray-200">
                      <span v-if="dish.price != null && dish.price != undefined && dish.price != ''" class="inline-flex items-center px-2 text-xs font-medium leading-5 text-indigo-700 bg-indigo-100 rounded-md ">
                        {{ dish.price.toFixed(2)  }} {{ dish.unit }}
                      </span>
                    </td>
                    
                   
                    <td class="px-6 py-4 text-sm leading-5 text-gray-500 border-b border-gray-200">
                      <div class="" v-if="dish.allergens != null">
                          <span v-for="allergy in getDishesAllergen(dish.allergens)" :key="dish.id+'_allergy_'+allergy.id" >                            
                              <img :title="allergy.name" :src="getIconAllergen(allergy.icon, locationIconStyle)" class="inline-block w-5 h-5 mr-2" >
                          </span>
                        </div>
                    </td>

                    <td class="px-6 py-4 text-sm leading-5 text-gray-500 border-b border-gray-200">
                      <div class="" v-if="dish.attributes != null">
                        <span v-for="attribute in getDishesAttribute(dish.attributes)" :key="'allergy'+attribute.id" >
                          <img :title="attribute.name" :src="getIconAttribute(attribute.icon, locationIconStyle)" class="inline-block w-5 h-5 mr-2" >
                        </span>
                      </div>
                    </td>

                    <td class="px-6 py-4 text-sm font-medium leading-5 text-right whitespace-no-wrap border-b border-gray-200">
                      <!--
                      <router-link :to="{name:'Dish', params:{ id: id, iddish: dish.id}}" class="text-indigo-600 hover:text-indigo-900">Modifica
                      </router-link>
                      -->
                      <svg class="inline-block w-5 h-5 mr-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                      </svg>
                    </td>
                    
                  </router-link>
                </tbody>
              </table>

            <div v-if="counterCategoryDish[category.id] != undefined && counterCategoryDish[category.id] == 0">
              <div class="inline-block min-w-full p-5 overflow-hidden text-center align-middle bg-white shadow sm:rounded-md">

                <div class="mx-auto">
                  <div class="flex items-center justify-center flex-shrink-0 mx-auto rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 286.001 286" class="w-12 h-12"><defs><linearGradient id="dishesb" x1=".089" y1=".068" x2=".908" y2=".94" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#71ff9c"></stop><stop offset=".309" stop-color="#3bdcaa"></stop><stop offset="1" stop-color="#04b8b8"></stop></linearGradient><filter id="dishesa" x="0" y="0" width="286.001" height="286" filterUnits="userSpaceOnUse"><feOffset dx="8" dy="15"></feOffset><feGaussianBlur stdDeviation="5" result="blur"></feGaussianBlur><feFlood flood-opacity=".161"></feFlood><feComposite operator="in" in2="blur"></feComposite><feComposite in="SourceGraphic"></feComposite></filter></defs><g filter="url(#dishesa)"><path data-name="dasch_cappello2" d="M233 256H23a23 23 0 01-23-23V23A23 23 0 0123 0h210a23 23 0 0123 23v210a23 23 0 01-23 23zM80.055 173.255a3.222 3.222 0 00-3.215 3.212l-.013 9.373a13.118 13.118 0 0013.117 13.132h76.625a13.131 13.131 0 0013.116-13.116v-9.386a3.218 3.218 0 00-3.215-3.215zM85.12 71.439a3.234 3.234 0 00-.77.093 35.274 35.274 0 00-7.459 65.728l-.035 26.348a3.249 3.249 0 00.94 2.276 3.205 3.205 0 002.275.941h96.4a3.218 3.218 0 003.215-3.215v-26.4a35.341 35.341 0 00-16.073-66.827 33.2 33.2 0 00-6.132.6A38.545 38.545 0 0089.674 96.1a3.215 3.215 0 01-6.43 0A44.4 44.4 0 0188 76.091a3.212 3.212 0 00-2.884-4.652zm68.848 76.1a3.215 3.215 0 01-2.486-5.252c3.447-4.21 8.915-12.617 8.915-17.251a3.215 3.215 0 016.43 0c0 3.541-1.611 8.03-4.788 13.344a70.486 70.486 0 01-5.584 7.985 3.215 3.215 0 01-2.488 1.174zm-25.717 0a3.218 3.218 0 01-3.215-3.215v-19.289a3.215 3.215 0 016.43 0v19.289a3.218 3.218 0 01-3.216 3.215zm-25.714 0a3.218 3.218 0 01-2.489-1.174 70.485 70.485 0 01-5.584-7.985c-3.177-5.314-4.788-9.8-4.788-13.344a3.215 3.215 0 016.43 0c0 4.651 5.468 13.047 8.915 17.248a3.216 3.216 0 01-2.483 5.256z" transform="translate(7)" fill="url(#dishesb)"></path></g></svg>                  </div>
                </div>

                <p class="mt-1 text-base">Non sono presenti piatti, creane uno adesso!</p>
                <router-link :to="{ name : 'DishCreate',  params : { id, catid: category.id }}" type="button" class="relative inline-flex items-center px-4 py-2 mt-4 text-sm font-medium leading-5 text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700">
                  Crea nuovo piatto
                </router-link>

              </div>
            </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DishService from '../apis/DishService';
import IconService from '../apis/IconService';
import LocationService from '../apis/LocationService';
 

export default {
  props: {
    id: Number
  },
  data() {
    return {
      counterCategoryDish:{},
      categories: [],
      dishes: [],
      allergens:[],
      attributes:[],
      dishesCounter: 0,
      count: 0,
      action: this.$route.meta.action,
      locationColor: {},
      locationIconStyle: 1,
      showEmpty: false,
    };
  },
   mounted() {
 

    this.loadLocationConfig();

     DishService.getDishes(this.id).then(response => {
      this.categories = response.data.data.categories;
      this.dishes = response.data.data.dishes;
      this.allergens = response.data.data.allergens;
      this.attributes = response.data.data.attributes;
      if(this.categories.length == 0){
        this.showEmpty = true;
      }else{
        for(let i=0; i<this.categories.length;i++){
          this.$set(this.counterCategoryDish, this.categories.id, undefined);
        }
      }

      if(this.$route.hash.includes("#cat")){
        this.$nextTick(() => {
          let el = document.getElementById(this.$route.hash.replace("#", ""));
          if (el) {
            el.scrollIntoView();
          }
        });
      }
    });
    
  },
  created(){
  },
  methods: {

    getDishImage: function(url){
      return IconService.getDishImage(url);
    },

    getCategoryIcon: function(url){
      return IconService.getIconCat(url);
    },

    getIconAttribute: function(iconid, styleid){
      return IconService.getIconAttribute(iconid, styleid);
    },

    getIconAllergen: function(iconid, styleid){
      return IconService.getIconAllergen(iconid, styleid);
    },

    getDishesOfCategory: function(cat){
      //this.$set(this.counterCategoryDish, "cat" + cat.id, {});

      let result = this.dishes.filter(x => x.dish_category_id === cat.id);
      console.log("a");

      this.counterCategoryDish[cat.id] = result.length;

      return result;
    },

    getDishesAllergen: function(al){
      let list = al.split(",").map(i=>Number(i));
      return this.allergens.filter(x=> list.includes(x.id));
    },

    getDishesAttribute: function(at){
      let list = at.split(",").map(i=>Number(i));
      return this.attributes.filter(x=> list.includes(x.id));
    },
    

    loadLocationConfig: function(){

      let location = this.$store.getters.locationById(this.id);
      if (location.length == 1){
        this.locationColor = location[0].color;
        this.locationIconStyle = location[0].icon_style_id;
      }else{
        LocationService.getLocation(this.id).then(response => {
          this.locationColor = response.data.data.color;
          this.locationIconStyle = response.data.data.icon_style_id;
        });
      }
    },
  }
};
</script>
